import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { SocialUserSignUp } from 'app/shared/models/class/user/user';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UsersService } from 'app/shared/services/users/users.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-register-rs',
  templateUrl: './register-rs.component.html',
  styleUrls: ['./register-rs.component.scss']
})
export class RegisterRsComponent extends SubscriptionBaseComponent implements OnInit {

  @Input() userRS: any;

  date = new Date();
  checked = false;

  confirm = false;
  signUpForm: UntypedFormGroup;
  confirmSignUp = false;

  isLoading = false;

  constructor(
    private dataService: DataService,
    public uiService: UiService,
    private cdr: ChangeDetectorRef,
    private authService: AuthService,
    private usersService: UsersService,
    private formBuilder: UntypedFormBuilder,
    private dialog: MatDialog,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initForm();
    this.initSub();
  }

  // checks if the terms of use are accepted
  isCheck(): void {
    this.checked = !this.checked;
  }

  confirmToRegister(): void {
    this.isLoading = true;
    const newUser: SocialUserSignUp = {
      user: {
        username: this.userRS.firstName,
        firstName: this.userRS.firstName,
        lastName: this.userRS.lastName,
        email: this.userRS.email,
        isActive: true,
        role: {
          id: 2
        },
      },
      socialId: this.userRS.id,
      type: this.userRS.provider
    };

    if (this.f.licence.value) {
      newUser.user.licenceKey = this.f.licence.value;
    }

    this.usersService.signup(newUser).subscribe({
      next: res => {
        this.confirmSignUp = true;
        this.isLoading = false;
        this.authService.loginSocial(this.userRS.authToken, this.userRS.id, this.userRS.provider, this.userRS.email).subscribe(() => { },
          (error) => { });

        setTimeout(() => {
          this.confirmSignUp = false;
          this.dialog.closeAll();
        }, 7000);
      },
      error: error => { this.uiService.showSnackbar('Le nom d\'utilisateur existe déjà'); }
    });

  }

  get f() {
    return this.signUpForm.controls;
  }

  private initForm(): void {
    this.signUpForm = this.formBuilder.group({
      username: ['', Validators.required],
      email: ['', Validators.required],
      licence: ['']
    });
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.jsonResauxSocial$.subscribe({
          next: userRS => { this.userRS = userRS; this.cdr.detectChanges(); }
        })
      );
  }
}
